module.exports = __webpack_public_path__ + "static/img/cCT5.84030940.png";